import React from "react";
import { useT } from "i18n";
import "./FeaturesPlaceholder.scss";

const FeaturesPlaceholder = () => {
  const t = useT();
  return (
    <div className={"features-placeholder"}>
      <div className={"features-placeholder__copy"}>
        {t(
          "component.orders.noFeaturesTagged",
          "No features were tagged during measuring. Click 'Next' to continue.",
        )}
      </div>
    </div>
  );
};

export default FeaturesPlaceholder;
